module.exports = __webpack_public_path__ + "img/1F1EC-1F1ED.5d18b3e2.svg";